

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser } from '@/interfaces/user';
import { IGroup } from '../../interfaces/group';

@Component({
  components: {
  },
})
export default class GroupList extends Vue {
  @Prop({ required: true })
  public group!: IGroup;

  public get groups(): IGroup[] {
    return this.group && this.group.groups;
  }

  
}
